export interface Step {
  active: boolean;
  previous: boolean;
}
